/* eslint-disable camelcase */
import React from 'react';
import { RichText } from 'prismic-reactjs';
import { IPrismicImage, IPrismicText } from '@lib/prismic/types';
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import breakpoints from '@constants/breakpoints';
import { useTheme } from '@components/theme';

import styles from './CoreValues.module.scss';

interface ICoreValuesProps {
    heading: string;
    coreValues: ICoreValues[];
}

export interface ICoreValues {
    core_description: IPrismicText[];
    core_title: IPrismicText[];
    image: IPrismicImage;
}

const CoreValues = ({
  heading,
  coreValues,
}: ICoreValuesProps) => {
  const theme = useTheme();
  return (
    <div className={styles.Container}>
      <h2 className={theme.styles.Header}>{heading}</h2>
      <div className={styles.Values}>
        {coreValues.map(({ core_description, image, core_title }: ICoreValues) => {
          const title = RichText.asText(core_title);
          return (
            <div key={title}>
              <PrismicImage
                className={ styles.Image }
                image={image}
                breakpoints={{
                  mobile: breakpoints.desktop
                }}
              />
              <h3 className={theme.styles.Title1}>{title}</h3>
              <p className={theme.styles.Body}>{RichText.asText(core_description)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CoreValues;
